export default "__VITE_ASSET__DW0R$Hno__"